import $ from 'jquery';
import 'slick-carousel';

/**
 * Wrapper of Slick Slider
 */
export default class Slider {
  constructor(el, options) {
    this.el = $(el);
    this.options = options;

    this.init();
  }

  init() {
    this.el.slick(this.options);
  }
}
